import { useSyncExternalStore } from "react";

interface SidebarState {
  isCollapsed: boolean;
  isMobileOpen: boolean;
}

const getInitialCollapsed = (): boolean => {
  if (typeof window === "undefined") return false;
  try {
    return localStorage.getItem("threatactix_sidebar_collapsed") === "true";
  } catch {
    return false;
  }
};

let state: SidebarState = {
  isCollapsed: getInitialCollapsed(),
  isMobileOpen: false,
};

const listeners = new Set<() => void>();

function notify() {
  listeners.forEach((listener) => listener());
}

export const sidebarStore = {
  getSnapshot: () => state,
  subscribe: (listener: () => void) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
  toggleCollapsed: () => {
    state = { ...state, isCollapsed: !state.isCollapsed };
    try {
      localStorage.setItem("threatactix_sidebar_collapsed", String(state.isCollapsed));
      document.documentElement.style.setProperty(
        "--sidebar-w",
        state.isCollapsed ? "76px" : "264px"
      );
    } catch {}
    notify();
  },
  setCollapsed: (isCollapsed: boolean) => {
    state = { ...state, isCollapsed };
    try {
      localStorage.setItem("threatactix_sidebar_collapsed", String(isCollapsed));
      document.documentElement.style.setProperty(
        "--sidebar-w",
        isCollapsed ? "76px" : "264px"
      );
    } catch {}
    notify();
  },
  toggleMobileOpen: () => {
    state = { ...state, isMobileOpen: !state.isMobileOpen };
    notify();
  },
  setMobileOpen: (isMobileOpen: boolean) => {
    state = { ...state, isMobileOpen };
    notify();
  },
};

export function useSidebarStore() {
  const current = useSyncExternalStore(sidebarStore.subscribe, sidebarStore.getSnapshot);
  return {
    isCollapsed: current.isCollapsed,
    isMobileOpen: current.isMobileOpen,
    toggleCollapsed: sidebarStore.toggleCollapsed,
    setCollapsed: sidebarStore.setCollapsed,
    toggleMobileOpen: sidebarStore.toggleMobileOpen,
    setMobileOpen: sidebarStore.setMobileOpen,
  };
}
